
  export default {
    name: `MyCheckIDStatus`
  }
